import { React, useState } from "react"
import AgreeButton from "../AgreeButton"
import TnCModal from "../TnCModal"
import PrivacyModal from "../PrivacyModal"

function DefaultFooter({ id, rrn, clientName, opt, redirect }) {
  // modal state
  const [openModal, setOpenModal] = useState("")

  const openTnCModal = () => {
    setOpenModal("tnc")
  }

  const openPrivModal = () => {
    setOpenModal("privacy")
  }

  const closeModal = () => {
    setOpenModal("")
  }

  return (
    <>
      <div className="footer">
        <p className="footer-text">
          {" "}
          By proceeding, you allow {clientName} to share the above information
          with this partner in line with our{" "}
          <button type="button" className="link-button" onClick={openTnCModal}>
            <b> Terms & Conditions </b>
          </button>{" "}
          and{" "}
          <button type="button" className="link-button" onClick={openPrivModal}>
            <b>Privacy Policy</b>
          </button>
          .
        </p>

        <AgreeButton id={id} rrn={rrn} opt={opt} redirect={redirect} />
      </div>

      <div className="modals">
        <TnCModal visible={openModal === "tnc"} closeModal={closeModal} />
        <PrivacyModal
          visible={openModal === "privacy"}
          closeModal={closeModal}
        />
      </div>
    </>
  )
}

export default DefaultFooter
